module.exports = function(renderer, stage) {
  return function renderScene(entities, elapsed) {
    var ids = entities.find("graphics");
    renderer.render(stage);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/systems/renderScene.js
// module id = 240
// module chunks = 0